module.exports = __webpack_public_path__ + "img/faceb.ba1cb168.png";